module.exports = __webpack_public_path__ + "static/media/article-thumb.19046777.png";